import React from "react";

const PreviewImage = ({ src }) => {
  const [imageContent, setImagecontent] = React.useState(null);

  const reader = new FileReader();
  reader.readAsDataURL(src);
  reader.onload = () => {
    setImagecontent(reader.result);
  };

  return <img src={imageContent} alt="apercu" className="img-fluid" />;
};

export default PreviewImage;
